<template>
  <a-modal
    v-if="datasource"
    title="Edit Detail"
    :visible="modalEdit"
    @ok="handleModalEditOk"
    :confirm-loading="confirmLoading"
    @cancel="handleCancel"
    cancelText= 'Cancel'
    :maskClosable="false"
  >
    <a-alert
      message="Exceeded limit Value"
      :description="'Your report has exceeded the limit of ' + limitasi"
      type="error"
      closable
      v-if="errorText"
      @close="alertClose"
    />
    <a-form :form="formEdit">
      <a-form-item label="PP/SPPD Detail">
        <a-select
          showSearch
          placeholder="PP/SPPD Detail"
          class="select-between c_noumpd"
          v-decorator="[
            'pppd_detail',
            { rules: [{ required: true }], initialValue: datasource.selected_pppd },
          ]"
          option-filter-prop="children"
            :filter-option="filterOption"
          @change="handleChangeumDtl"
          disabled
        >
          <a-select-option v-for="item in datasource.list_pppd" :key="item.id_trans_dtl">
            <div class="select-option">
              <div v-if="!getScreen">
                <h4>{{ item.item_nm }}</h4>
              </div>
              <h4 v-else>{{ item.item_nm }}</h4>
              <small>{{
                formatRupiah(item.saldo)
                  .replace(",00", "")
              }}</small>
            </div>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Description">
        <a-input
          v-decorator="[
            'deskripsi',
            { rules: [{ required: true }], initialValue: datasource.deskripsi },
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Usage Date">
        <a-date-picker
          placeholder="Select Date"
          :format="getDefaultDateFormat"
          v-decorator="[
            'tanggal_pemakaian',
            {
              rules: [{ required: true }],
              initialValue: datasource.tanggal_pemakaian,
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="Credit">
        <a-input-number
          :min="0"
          class="m-width-full m-text-align-right"
          :formatter="
            (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
          v-decorator="[
            'kredit',
            {
              rules: [{ required: true }, { validator: checkPrice }],
              initialValue: datasource.kredit,
            },
          ]"
        />
      </a-form-item>
      <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: datasource.iscommision },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: datasource.without_note },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
        </a-row>
        <a-form-item label="Upload Transaction Document">
          <a-upload
            :showUploadList="true"
            :fileList="doctransfiles"
            :beforeUpload="beforedoctransUpload"
            v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
            :remove="handledoctransRemove"
          >
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import axios from "axios";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  props: {
    modalEdit: Boolean,
    datasource: Object,
  },
  mixins: [CurrencyFormat, GlobalMethod],
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getAuth",
      "getScreen",
      "getStandartFormatDate",
    ]),
  },
  data() {
    return {
      errorText: false,
      confirmLoading: false,
      EnCommission: false,
      Viwithout_note: false,
      doctransfiles: [],
    };
  },
  beforeCreate() {
    this.formEdit = this.$form.createForm(this);
  },
  mounted(){
    this.fetch()
  },
  watch:{
    datasource(){
      this.fetch()
    }
  },
  methods: {
    moment,
    fetch(){
      if(this.datasource && this.datasource.id){
        this.EnCommission = this.datasource.EnCommission;
        this.Viwithout_note = this.datasource.Viwithout_note;
        this.doctransfiles = this.datasource.doctransfiles;

        if(this.datasource.lampiran)
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: this.datasource.lampiran_path,
        })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(this.datasource.lampiran);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            this.datasource.lampiran
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + this.datasource.lampiran_path;
          this.doctransfiles = [];
          this.doctransfiles.push(file);
          console.log(this.doctransfiles)
        })
          .catch((err) => {
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      }
    },
    alertClose() {
      this.errorText = false;
    },
    handleCancel(e) {
      Event.$emit("modalEditCancel", false);
      this.formEdit.resetFields();
      this.errorText = false;
    },
    handleModalEditOk() {
      this.formEdit.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Usage date can't exceed today!");
          return;
        }
        
        let url =
          this.datasource.type === "revised"
            ? "bailout_report/revisi_detil_pemakaian_edit"
            : "bailout_report/detil_pemakaian_edit";

        let addData = new FormData();
        addData.append("id", this.datasource.id);
        addData.append("id_trans_dtl", values.pppd_detail);
        addData.append("tanggal_pemakaian", moment(
            values.tanggal_pemakaian
          ).format(this.getStandartFormatDate));
        addData.append("deskripsi", values.deskripsi);
        addData.append("kredit", values.kredit);
        addData.append("iscommision", values.iscommision);
        // addData.append("without_note", values.without_note);
        addData.append("without_note", "1");

        if (this.doctransfiles && this.doctransfiles.length > 0) {
          this.doctransfiles.forEach((file) => {
            addData.append("file_upload", file);
          });
        }

        this.confirmLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + url,
          processData: false,
          data: addData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((res) => {
          Event.$emit("fetchBailloutDtlList");
          this.formEdit.resetFields();
          this.errorText = false;
          Event.$emit("modalEditCancel", false);
          Event.$emit("fetchUmList", true);
          this.confirmLoading = false;
        })
        .catch((err) => {
          console.log(err.response);
          this.confirmLoading = false;
          this.displayMessageValue("error-other", err.response.data.message);
        });
      });
    },
    checkPrice(rule, value, callback) {
      if (value >= 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.formEdit.setFieldsValue({
            without_note: "1",
        });
      });
    },
    handleChangeumDtl(val){
      let selectedumDtl = _.filter(this.datasource.list_um, { id_um_dtl: val });
      //console.log(selectedumDtl,this.ppdetillist);
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
};
</script>

<style lang="less">
.c_noumpd{
  .ant-select-selection__rendered{
    overflow: auto;
  }
}
</style>
